const mediaQueries = [
  {
    query: window.matchMedia('(min-width: 39.9375rem)'),
    type: 'xs'
  },
  {
    query: window.matchMedia('(min-width: 47.4375rem)'),
    type: 'sm'
  },
  {
    query: window.matchMedia('(min-width: 63.6875rem)'),
    type: 'md'
  },
  {
    query: window.matchMedia('(min-width: 77.4375rem)'),
    type: 'lg'
  }
]

const bestOfLinks = [
  {
    title: 'Chase Freedom Unlimited®',
    route: route('content.fetch.subcategory', [
      'credit-cards',
      'reviews',
      'chase-freedom-unlimited'
    ])
  },
  {
    title: 'Capital One® Venture® Rewards Credit Card',
    route: route('content.fetch.subcategory', [
      'credit-cards',
      'reviews',
      'capital-one-venture-rewards-credit-card'
    ])
  },
  {
    title: 'Chase Slate®',
    route: route('content.fetch.subcategory', [
      'credit-cards',
      'reviews',
      'chase-slate'
    ])
  },
  {
    title: 'Citi® Simplicity',
    route: route('content.fetch.subcategory', [
      'credit-cards',
      'reviews',
      'citi-simplicity-card'
    ])
  },
  {
    title: 'Citi® Double Cash',
    route: route('content.fetch.subcategory', [
      'credit-cards',
      'reviews',
      'citi-double-cash-card'
    ])
  }
]

const orderOptions = [
  {
    name: 'Highest',
    slug: 'desc'
  },
  {
    name: 'Lowest',
    slug: 'asc'
  }
]

export default { mediaQueries, bestOfLinks, orderOptions }
